import React from 'react';

import {Card, CardContent, CardHeader, Stack, TextField, Typography} from '@mui/material';
import {useQuery} from 'react-query';

import API, {FlightPathGetProps, Types} from '@wheeebo/polaris-api';
import {CircleLoader, LoadError} from '@wheeebo/polaris-ui';

interface Props {
  flightPathId: Types.UUID;
  onMissionSelected: (missionId: Types.UUID) => void;
}

const FlightPathProfileCard = ({flightPathId, onMissionSelected}: Props): JSX.Element => {
  const options: FlightPathGetProps = {preload: ['mission']};
  const {data, isLoading, isError} = useQuery(API.FlightPaths.getKey(flightPathId, options), () =>
    API.FlightPaths.get(flightPathId, options),
  );
  return (
    <Card variant="outlined" sx={{zIndex: 1}}>
      <CardHeader title="Flight Path Profile" />
      <CardContent>
        {isLoading ? <CircleLoader /> : null}
        {isError ? <LoadError /> : null}
        {data ? (
          <Stack gap={1}>
            <TextField
              disabled
              fullWidth
              variant="standard"
              label="Mission"
              multiline
              inputProps={{
                style: {cursor: 'pointer', textDecoration: 'underline'},
              }}
              InputProps={{
                onClick: () => onMissionSelected(data?.mission?.id),
              }}
              value={data?.mission?.name || ''}
            />
            <TextField disabled fullWidth variant="standard" label="Flight Path ID" value={flightPathId} />
            <TextField
              disabled
              fullWidth
              variant="standard"
              label="Flight Path Name"
              multiline
              value={data?.name || ''}
            />
          </Stack>
        ) : (
          <Typography variant="body2">No record found.</Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default React.memo(FlightPathProfileCard);
